module.exports = __webpack_public_path__ + "img/mercadopago.6a608790.png";